import { TableDetailsItemDto, TableDetailsPaymentDto, TableDetailsPaymentItemDto } from "../../services/tables/dto/table-details-dto";
import { CloseType } from "../services/table.service";
import { TableItem } from "./table-item";
import dayjs from '../../utils/dayjs';

export class PaymentDone {
  id: number;
  paymentIdentifier: string;
  paymentMethod: string;
  paymentUuid: string;
  status: string;
  taxPaid: boolean;
  userId: number;
  userName: string;
  value: number;
  createdAt: string;
  items?: PaymentItem[];
  type: CloseType;
  tz: string = 'America/Sao_Paulo';

  constructor(payment: TableDetailsPaymentDto, tz: string) {
    this.id = payment.id;
    this.paymentIdentifier = payment.paymentIdentifier;
    this.paymentMethod = payment.paymentMethod;
    this.paymentUuid = payment.paymentUuid;
    this.status = payment.status;
    this.taxPaid = payment.taxPaid;
    this.userId = payment.userId;
    this.userName = payment.userName;
    this.value = payment.value;
    this.createdAt = payment.createdAt;
    this.items = [];
    this.type = payment.type as CloseType;
    this.tz = tz;

    for(let item of payment.items) {
      this.items.push(new PaymentItem(item))
    }
  }

  get tzDate() {
    return dayjs(this.createdAt).tz(this.tz).format('DD/MM/YYYY');
  }
  
  get tzHour() {
    return dayjs(this.createdAt).tz(this.tz).format('HH:mm');
  }
}

export class PaymentItem {
  qty: number;
  item: TableItem;
  value: number

  constructor(paymentItem: TableDetailsPaymentItemDto) {
    this.qty = paymentItem.qty;
    this.item = new TableItem(paymentItem.item);
    this.value = paymentItem.value;
  }
}